import styled from "styled-components";
import {VoucherCardSideBox} from "../voucher-card-side.box";

export const VoucherCardBackBox = styled(VoucherCardSideBox)`
    align-items: flex-start;
    transform: rotateY(${({backSideShown}) => backSideShown ? "0" : "180deg"});
`;
